import * as Sentry from '@sentry/react';
import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import reduxPromise from 'redux-promise';
import createSagaMiddleware from 'redux-saga';
import ReduxThunk from 'redux-thunk';
import { featureFlagsSaga } from '../common';
import { importFixedAllocationsSaga } from '../features/models/composition/store/sagas/fixed/allocationsImporterSaga';
import { importWeightedAllocationsSaga } from '../features/models/composition/store/sagas/weighted/allocationsImporterSaga';
import { importTradesSaga } from '../features/orders/rebalance/edit/store/sagas/importSaga';
import { AppStore, setAppStore } from './appStore';
import reducers from './reducer';

const sagaMiddleware = createSagaMiddleware();

const sentryReduxEnhancer = Sentry.createReduxEnhancer({});

export const store = createStore(
  reducers,
  composeWithDevTools(applyMiddleware(sagaMiddleware, ReduxThunk, reduxPromise), sentryReduxEnhancer)
);

sagaMiddleware.run(importTradesSaga);
sagaMiddleware.run(featureFlagsSaga);
sagaMiddleware.run(importFixedAllocationsSaga);
sagaMiddleware.run(importWeightedAllocationsSaga);

setAppStore(store as AppStore);
